export const NETWORKS = {
  [process.env.REACT_APP_EARTH_CHAIN_ID]: {
    chainId: process.env.REACT_APP_EARTH_CHAIN_ID,
    nativeCurrency: {
      name: process.env.REACT_APP_EARTH_NATIVE_CURRENCY_NAME,
      symbol: process.env.REACT_APP_EARTH_NATIVE_CURRENCY_SYMBOL,
      decimals: parseInt(process.env.REACT_APP_EARTH_NATIVE_CURRENCY_DECIMALS, 10)
    },
    rpcUrls: [process.env.REACT_APP_EARTH_RPC_URL],
    blockExplorerUrls: [process.env.REACT_APP_EARTH_EXPLORER_URL],
    color: '#3498db',
    gasLimit: 21000,
    blockTime: 12,
    consensusMechanism: 'PoS',
    networkType: 'Mainnet',
    supportedStandards: ['ERC20', 'ERC721']
  }
};